<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('yearlyExpenseItem.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('yearlyExpenseItem.pageTitle'),
						active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
						<ts-loading-banner :loading="loading">
							<form>
								<fieldset>
									<legend>{{ $t('yearlyExpenseItem.criteria') }}</legend>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{ $t('yearlyExpenseItem.year')}}</label>
											<ts-year-picker-input v-model="model.year" />
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{ $t('yearlyExpenseItem.item')}}</label>
											<a-select
												v-model="model.item_id"
												:options="items"
                        showSearch
                        :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0" 
												placeholder="All" mode="multiple" class="ts-w-full"></a-select>
										</div>
									</div>
                    <div class="row">
                      <div class="col-md-6 text-right">
                        <ts-button
                          class="btn-block"
                          outline
                          color="success"
                          @click.prevent="exportExcel"
                          :waiting="exporting"
                          ><i class="fas fa-file-excel"></i>
                          {{ $t('excel') }}</ts-button
                        >
                      </div>
                      <div class="col-md-6 text-right">
                        <ts-button
                          class="btn-block"
                          color="primary"
                          @click.prevent="preview"
                          :waiting="waiting"
                          ><i class="fas fa-file-pdf text-red"></i>
                          {{ $t('preview') }}</ts-button
                        >
                      </div>
                    </div>
								</fieldset>
							</form>
						</ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('yearlyExpenseItem.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'yearlyExpenseItem',
  data() {
    return {
      loading: false,
      waiting: false,
      exporting: false,
      src: null,
			errors: new Errors(),
			items: [],
      model: {
        year: moment().format('YYYY'),
        item_id: undefined
      }
    }
	},
	created(){
		this.fetchData()
	},
  methods: {
		...mapActions('report/expense', ['expenseItem', 'getExpenseItem']),
		async fetchData() {
      this.loading = true
      await this.getExpenseItem()
        .then(response => {
          this.items = response.data.map(el => ({
            value: el.exp_id,
            label: el.exp_item
          }))
				})
				.finally(() => {
					this.loading = false
				})
		},
    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.expenseItem(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel () {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch('report/expense/expenseItemExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
  }
}
</script>